"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _excluded = ["borderColor", "backgroundColor", "tick", "tickColor", "isMedium"],
  _excluded2 = ["isMedium"],
  _excluded3 = ["isMedium"],
  _excluded4 = ["isMedium", "checked"],
  _excluded5 = ["isMedium"],
  _excluded6 = ["isMedium", "sx", "isChecked", "variant"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CheckboxBox = function CheckboxBox(_ref) {
  var borderColor = _ref.borderColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'red' : _ref$backgroundColor,
    tick = _ref.tick,
    tickColor = _ref.tickColor,
    isMedium = _ref.isMedium,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_icons.Svg, _extends({
    width: isMedium ? 20 : 16,
    height: isMedium ? 20 : 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "4",
    ry: "4",
    fill: backgroundColor,
    stroke: borderColor
  }), tick && /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 5,8 L 7,10 L 12,5",
    stroke: tickColor,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })));
};
var CheckboxChecked = function CheckboxChecked(_ref2) {
  var isMedium = _ref2.isMedium,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(CheckboxBox, _extends({
    borderColor: "#6A88F2",
    backgroundColor: "#6A88F2",
    tick: true,
    tickColor: "white",
    isMedium: isMedium
  }, props));
};
var _StyledCheckboxChecked = (0, _styledComponents["default"])(CheckboxChecked)({
  display: 'none',
  'input:checked:not(:disabled) ~ &': {
    display: 'block'
  }
});
var CheckboxUnchecked = function CheckboxUnchecked(_ref3) {
  var isMedium = _ref3.isMedium,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(CheckboxBox, _extends({
    borderColor: "#C1CCD0",
    backgroundColor: "white",
    isMedium: isMedium
  }, props));
};
var _StyledCheckboxUnchecked = (0, _styledComponents["default"])(CheckboxUnchecked)({
  display: 'none',
  'input:not(:checked):not(:disabled) ~ &': {
    display: 'block'
  }
});
var CheckboxDisabled = function CheckboxDisabled(_ref4) {
  var isMedium = _ref4.isMedium,
    _ref4$checked = _ref4.checked,
    checked = _ref4$checked === void 0 ? false : _ref4$checked,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(CheckboxBox, _extends({
    borderColor: "#EFF2F3",
    backgroundColor: "#EFF2F3",
    tick: checked,
    tickColor: "#C1CCD0",
    isMedium: isMedium
  }, props));
};
var _StyledCheckboxDisabled2 = (0, _styledComponents["default"])(CheckboxDisabled).withConfig({
  componentId: "sc-11rg310-0"
})({
  display: 'none',
  'input:checked:disabled ~ &': {
    display: 'block'
  }
});
var _StyledCheckboxDisabled = (0, _styledComponents["default"])(CheckboxDisabled)({
  display: 'none',
  'input:disabled:not(:checked) ~ &': {
    display: 'block'
  }
});
var CheckboxIcon = function CheckboxIcon(_ref5) {
  var isMedium = _ref5.isMedium,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledCheckboxChecked, _extends({
    isMedium: isMedium
  }, props)), /*#__PURE__*/_react["default"].createElement(_StyledCheckboxUnchecked, _extends({
    isMedium: isMedium
  }, props)), /*#__PURE__*/_react["default"].createElement(_StyledCheckboxDisabled, _extends({
    isMedium: isMedium
  }, props)), /*#__PURE__*/_react["default"].createElement(_StyledCheckboxDisabled2, _extends({
    isMedium: isMedium,
    checked: true
  }, props)));
};
var Checkbox = exports.Checkbox = function Checkbox(_ref6) {
  var _ref6$isMedium = _ref6.isMedium,
    isMedium = _ref6$isMedium === void 0 ? false : _ref6$isMedium,
    sx = _ref6.sx,
    isChecked = _ref6.isChecked,
    _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? 'checkbox' : _ref6$variant,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: {
      width: 18,
      height: 18
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "input",
    type: "checkbox"
  }, props, {
    sx: {
      position: 'absolute',
      opacity: 0,
      overflow: 'hidden',
      width: '18px',
      height: '18px',
      cursor: 'pointer'
    }
  })), !isChecked && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: CheckboxIcon,
    "aria-hidden": "true",
    tx: "forms",
    variant: variant,
    isMedium: isMedium,
    sx: sx,
    __css: {
      mr: 2,
      borderRadius: 2,
      color: 'gray',
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        boxShadow: 'active'
      }
    }
  }), isChecked && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: CheckboxChecked,
    "aria-hidden": "true",
    tx: "forms",
    variant: variant,
    isMedium: isMedium,
    sx: sx,
    __css: {
      mr: 2,
      borderRadius: 2,
      color: 'gray',
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        boxShadow: 'active'
      }
    }
  }));
};